import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import DataTable from '../components/DataTable';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Swal from 'sweetalert2'
import GetPagePermission from '../components/GetPagePermission';
import PackingBomViewRateModal from '../components/PackingBomViewRateModal';

export default function Products() {

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return myToken != null ? JSON.parse(myToken) : '';
    };

    const hasProductStatusPermission = GetPagePermission("/product-status-change");
    const hasProductFormulationPermission = GetPagePermission("/product-formulation-view");
    const [tableGlobalSearch, setTableGlobalSearch] = useState('');
    const [newData, setNewData] = useState<any>({});

    const [projects, setProjects] = useState<any[]>([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [showInactiveProducts, setShowInactiveProducts] = useState(false);
    const [showFormulationModal, setShowFormulationModal] = useState(false);
    const [viewRateProduct, setViewRateProduct] = useState<any | null>(null);
    const [viewRateDefaultBomId, setViewRateDefaultBomId] = useState<number | null>(null);

    useEffect(() => {
        getAllProjects();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reloadTable = () => setNewData({ id: Date.now() });

    const getAllProjects = async () => {

        const url = process.env.REACT_APP_API_URL + 'projects';
        const response = await fetch(url, getRequestOptions());
        const data = await response.json();

        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setProjects(data.data)

        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setProjects(allProjects);
        }

    }

    const handleProjectChange = (selectedProject: any) => {
        setProject(selectedProject);
    }

    const handleShowInactiveProductsChange = (checked: boolean) => {
        setShowInactiveProducts(checked);
    }

    const parseBomList = (bomList: string | null) => {
        if (!bomList) {
            return [];
        }
        return bomList.split('|').map((entry) => {
            const [id, ...nameParts] = entry.split(':');
            return { id: Number(id), name: nameParts.join(':') };
        }).filter((bom) => bom.id && bom.name);
    };

    const openFormulationModal = (row: any, bom: any) => {
        setViewRateProduct({
            idProducts: row.idProducts,
            productName: row.productName || row.displayName,
            packing: row.packing,
            size: row.size,
            unitName: row.unitName,
        });
        setViewRateDefaultBomId(bom?.id ?? null);
        setShowFormulationModal(true);
    };

    const closeFormulationModal = () => {
        setShowFormulationModal(false);
        setViewRateProduct(null);
        setViewRateDefaultBomId(null);
    };

    const confirmStatusProduct = async (idProducts: number, status: string) => {
        var msgTxt1 = status === 'Inactive' ? 'INACTIVE' : 'ACTIVE'
        var msgTxt2 = status === 'Inactive' ? 'Deactivate' : 'Activate'
        const confirm = await Swal.fire({
            title: 'Are you sure to proceed?',
            text: "This will mark this product as " + msgTxt1,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, ' + msgTxt2 + ' it!',
        })
        if (confirm.value) {
            const requestOptions = postRequestOptions()
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}confirmStatusProduct/${idProducts}/${status}`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    reloadTable();
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: 'Could not update product status.',
                    })
                }
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: 'Could not update product status.',
                })
            }
        }
    }

    useEffect(() => {
        if (projects.length === 1) {
            setProject({ label: projects[0]['label'], value: projects[0]['value'] })
        }
    }, [projects])

    const renderStatusCell = (row: any) => (
        <>
            {row.idProducts !== undefined && row.status === 'Active' &&
                <span onClick={() => confirmStatusProduct(row.idProducts, 'Inactive')} className="btn btn-success btn-sm" style={{ cursor: 'pointer' }}>Active</span>
            }
            {row.idProducts !== undefined && row.status === 'Inactive' &&
                <span onClick={() => confirmStatusProduct(row.idProducts, 'Active')} className="btn btn-danger btn-sm" style={{ cursor: 'pointer' }}>Inactive</span>
            }
            {row.idProducts !== undefined && (!row.status || (row.status !== 'Active' && row.status !== 'Inactive')) &&
                <span onClick={() => confirmStatusProduct(row.idProducts, 'Active')} className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>Set Status</span>
            }
        </>
    );

    const renderFormulationCell = (row: any) => {
        const boms = parseBomList(row.bomList);
        if (boms.length === 0) {
            return <span className="text-muted">-</span>;
        }

        return (
            <div>
                {boms.map((bom: any, bomIndex: number) => (
                    <React.Fragment key={bom.id}>
                        {bomIndex > 0 && <hr className="my-1" />}
                        <button
                            type="button"
                            className="btn btn-link btn-sm p-0"
                            onClick={() => openFormulationModal(row, bom)}
                        >
                            {bom.name}
                        </button>
                    </React.Fragment>
                ))}
            </div>
        );
    };

    const columns = [
        { value: 'categoryName', title: 'Category', style: { textAlign: 'left' } },
        {
            value: 'displayName',
            title: 'Product Name',
            style: { textAlign: 'left' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                const isInactive = row.status === 'Inactive';
                return (
                    <span style={isInactive ? { backgroundColor: '#FAA0A0' } : {}}>
                        {row.displayName}
                    </span>
                );
            },
        },
        { value: 'productCode', title: 'Product Code', style: { textAlign: 'left' } },
        ...(hasProductStatusPermission ? [{
            value: 'status',
            title: 'Status',
            style: { textAlign: 'center' },
            hasActionsComponent: true,
            actionsComponent: renderStatusCell,
        }] : []),
        ...(hasProductFormulationPermission ? [{
            value: 'formulation',
            title: 'Formulation',
            style: { textAlign: 'center' },
            hasActionsComponent: true,
            actionsComponent: renderFormulationCell,
        }] : []),
        {
            value: 'packing',
            title: 'Packing',
            style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => `${row.packing} ${row.groupUnitName || ''}`.trim(),
        },
        {
            value: 'size',
            title: 'Size',
            style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => `${row.size} ${row.groupUnitName || ''}`.trim(),
        },
        {
            value: 'salePerUnit',
            title: 'Sale/Unit',
            style: { textAlign: 'right' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => Number(row.salePerUnit).toLocaleString('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }),
        },
        { value: 'unitName', title: 'Unit', style: { textAlign: 'right' } },
    ];

    const filters = columns.reduce((acc: Record<string, { filterType: string; filterValue: string }>, column) => {
        if (column.value !== 'action') {
            acc[column.value] = { filterType: 'like', filterValue: '' };
        }
        return acc;
    }, {});

    const itemColumns = [
        { value: 'itemName', title: 'Item Name', style: { textAlign: 'left' } },
        { value: 'itemCode', title: 'Item Code', style: { textAlign: 'center' } },
        { value: 'categoryName', title: 'Item Category', style: { textAlign: 'center' } },
        { value: 'unitName', title: 'Unit', style: { textAlign: 'center' } },
    ];

    const itemFilters = itemColumns.reduce((acc: Record<string, { filterType: string; filterValue: string }>, column) => {
        acc[column.value] = { filterType: 'like', filterValue: '' };
        return acc;
    }, {});

    const additionalPostData = {
        idProjects: project?.value ?? '',
        showInactive: showInactiveProducts,
    };

    const url = process.env.REACT_APP_API_URL + 'productsViewList';
    const itemUrl = process.env.REACT_APP_API_URL + 'items';
    const itemAdditionalPostData = { type: 'item' };

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header card-header-stretch overflow-auto'>
                    <div className='card-title mb-0'>
                        <h3 className='card-label'>All Product List</h3>
                    </div>
                </div>
                <div className="card-body">

                    <Tabs
                        defaultActiveKey="product"
                        id="uncontrolled-tab-example"
                        className="mb-3 ml-3 mr-3"
                    >
                        <Tab eventKey="product" title="Product">

                            <div className="d-flex justify-content-end mb-3">
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    className='btn btn-sm btn-primary'
                                    href={`${process.env.REACT_APP_BACKEND}productExport?export=true&idProjects=${project?.value ?? ''}&showOnlyWithStock=false&showOnlyWithCostSetup=false&sortBySize=false&searchProduct=${encodeURIComponent(tableGlobalSearch)}&token=${jwt()}`}
                                >
                                    <i className='fas fa-download me-1' /> Export
                                </a>
                            </div>

                            <div className="form-group row">
                                <label htmlFor="project" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Project</label>
                                <div className="col-lg-5">
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        placeholder={project.label}
                                    />
                                </div>
                                <div className="col-md-3" style={{ marginTop: "-10px" }}>
                                    <Form.Group controlId="showInactiveProducts">
                                        <Form.Label></Form.Label>
                                        <Form.Check
                                            type="switch"
                                            id="show-inactive-products-switch"
                                            label="Show Inactive Products"
                                            className="form-switch"
                                            checked={showInactiveProducts}
                                            onChange={(e) => handleShowInactiveProductsChange(e.target.checked)}
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            <div className='mt-6'>
                                <DataTable
                                    key={`${hasProductStatusPermission}-${hasProductFormulationPermission}`}
                                    url={url}
                                    columns={columns}
                                    filters={filters}
                                    newData={newData}
                                    additionalPostData={additionalPostData}
                                    defaultSortedColumn="categoryName"
                                    onValueChange={(state: any) => setTableGlobalSearch(state.globalSearch || '')}
                                />
                            </div>

                        </Tab>
                        <Tab eventKey="item" title="Item">
                            <div className='mt-6'>
                                <DataTable
                                    url={itemUrl}
                                    columns={itemColumns}
                                    filters={itemFilters}
                                    newData={newData}
                                    additionalPostData={itemAdditionalPostData}
                                    defaultSortedColumn="itemName"
                                    defaultSortOrder="ASC"
                                />
                            </div>
                        </Tab>


                    </Tabs>
                </div>

                {hasProductFormulationPermission && (
                    <PackingBomViewRateModal
                        show={showFormulationModal}
                        handleClose={closeFormulationModal}
                        product={viewRateProduct}
                        defaultPackingBomId={viewRateDefaultBomId}
                    />
                )}

            </div>

        </>
    )
}
